<script lang="ts">
  import {recap, user} from '@/store';
  import {onDestroy} from 'svelte';
  import {events} from '../RemotionElements/Util';

  let src = '';
  let errorMessage = '';

  const recapSubscription = recap.subscribe(value => {
    const composition = value.composition;
    for (let i = 0; i < composition.length; i++) {
      const element = composition[i];
      if (element.type === 'image-element' && element.properties) {
        if (element.properties.src === '') {
          const brandkit = $user.brandKit;
          if (brandkit) {
            element.properties.src = brandkit.logoUrl;
          } else {
            console.error('could not find brand kit');
          }
        }
        src = element.properties.src;
        break;
      }
    }
  });

  const maxFileSizeInMB = 5;
  const MB2Bytes = (bytes: number) => bytes * (1024 * 1024);

  const input = document.createElement('input');
  input.type = 'file';
  input.accept = 'image/png, image/webp, image/jpeg, image/avif';

  input.addEventListener('change', (event: Event) => {
    const input = event.target as HTMLInputElement;
    if (!input) {
      errorMessage = 'No input. Try again.';
      console.error('No input. Try again.');
      return;
    }

    const file = (input.files || [])[0];
    if (!file) {
      errorMessage = 'No file found. Try again.';
      console.error('No file found. Try again.');
      return;
    }

    if (file.size >= MB2Bytes(maxFileSizeInMB)) {
      errorMessage = `file size exceed the ${maxFileSizeInMB}MB. Please upload an image`;
      console.error(`file size exceed the ${maxFileSizeInMB}MB. Please upload an image`);
      return;
    }

    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.src = objectUrl;
    img.onload = async () => {
      if (img.width > 1024) {
        errorMessage = 'Image exceeds 1024px in width. Please upload an image less than 1024 in width.';
        console.error('Image exceeds 1024px in width. Please upload an image less than 1024 in width.');
        URL.revokeObjectURL(objectUrl);
        return;
      }

      try {
        await user.updateLogo(file);
        await user.getBrandKit();

        if (!$user.brandKit) {
          errorMessage = 'User brandkit not found';
          console.error('User brandkit not found');
          return;
        }

        const brandkit = $user.brandKit;

        src = brandkit.logoUrl;
        recap.update(value => {
          const composition = value.composition;
          for (let i = 0; i < composition.length; i++) {
            const element = composition[i];
            if (element.type === 'image-element' && element.properties) {
              element.properties.src = src;
              break;
            }
          }
          dispatchEvent(new Event(events.compositionUpdate));
          return value;
        });
        errorMessage = '';
      } catch (err) {
        errorMessage = 'Unable to set brandkit logo.';
        console.error('Unable to set brandkit logo.', err);
      } finally {
        URL.revokeObjectURL(objectUrl);
      }
    };
  });

  onDestroy(() => {
    recapSubscription();
  });
</script>

<div>
  <div class="flex w-full justify-between pb-4">
    <span class="flex w-full items-center font-medium">Logo</span>
    <button
      on:click={() => input.click()}
      class="flex h-24 w-full items-center justify-center overflow-hidden rounded-lg border-2 border-dashed px-4 py-2 {errorMessage !==
      ''
        ? 'border-rose-500'
        : ''}"
    >
      <img class="h-full" {src} alt="logo-pic" />
    </button>
  </div>
  {#if errorMessage !== ''}
    <p class="text-sm text-rose-500">{errorMessage}</p>
  {/if}
</div>
